import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import { any, bool, string } from 'prop-types'
import { Row } from '../../common'
import { FlexContainer } from '../../layouts/Wrapper/Base.components'

const CardContainer = styled(FlexContainer)`
  display: block;
  border-radius: 3px;
  background-color: #ffffff;
  min-width: 0;
  flex: 1;
  padding: 13px;
  ${({ bordered }) => bordered && css`
    border: solid 1px #eaeaea;
    border-radius: 3px;
  `}
  ${({ top = '0', right = '0', bottom = '0', left = '0', margin }) => `
    margin: ${margin || top}px ${margin || right}px ${margin || bottom}px ${margin || left}px;
  `}
  flex-grow: 1;
  box-sizing: border-box;
`

const CardHeaderContainer = styled.div`
  ${({ noHeaderDivider = false }) => !noHeaderDivider && css`
    border-bottom: 1px solid #eaeaea;
    padding-bottom: 6px;
    margin-bottom: 6px;
  `}
  ${({ fullHeader, headerBackgroundColor, borderLeftHeaderColor, borderBottomHeaderColor }) => fullHeader && css`
    background-color: ${headerBackgroundColor};
    margin: -13px -13px 0 -13px;
    padding: 13px 13px 0px 13px;
    border-radius: 3px 3px 0 0;
    ${({ borderLeftHeaderColor }) => borderLeftHeaderColor && css`border-left: 8px solid ${borderLeftHeaderColor};`}
    ${({ borderBottomHeaderColor }) => borderBottomHeaderColor && css`border-bottom: 3px solid ${borderBottomHeaderColor};`}
  `}
`

const CardFooterContainer = styled(FlexContainer)`
  flex: 1;
`

class CardHeader extends Component {
  static propTypes = {
    rightHeader: any,
    leftHeader: any,
    children: any,
    fullHeader: bool,
    headerBackgroundColor: string,
    borderLeftHeaderColor: string,
    borderBottomHeaderColor: string
  }
  static defaultProps = {
    rightHeader: null,
    leftHeader: null,
    fullHeader: false
  }
  render () {
    const { rightHeader, leftHeader, children, fullHeader, headerBackgroundColor, borderLeftHeaderColor, borderBottomHeaderColor, noHeaderDivider, ...props } = this.props
    if (!leftHeader && !rightHeader) return null
    return (
      <CardHeaderContainer
        fullHeader={fullHeader}
        headerBackgroundColor={headerBackgroundColor}
        borderLeftHeaderColor={borderLeftHeaderColor}
        borderBottomHeaderColor={borderBottomHeaderColor}
        noHeaderDivider={noHeaderDivider}
        {...props}
      >
        <Row>
          { leftHeader && leftHeader() }
          { rightHeader && rightHeader() }
        </Row>
        <Row>
          { children }
        </Row>
      </CardHeaderContainer>
    )
  }
}

class CardFooter extends Component {
  static propTypes = {
    children: any
  }

  render () {
    const { children } = this.props
    return (
      <CardFooterContainer direction='column'>
        { children && (<Row style={{ flexWrap: 'wrap' }}>{ children }</Row>) }
      </CardFooterContainer>
    )
  }
}

export default class Card extends Component {
  static propTypes = {
    headerChildren: any,
    rightHeader: any,
    leftHeader: any,
    bodyChildren: any,
    footerChildren: any,
    fullHeader: bool,
    headerBackgroundColor: string,
    borderLeftHeaderColor: string,
    borderBottomHeaderColor: string
  }
  static defaultProps = {
    headerChildren: () => {},
    bodyChildren: () => {},
    footerChildren: () => {}
  }
  render () {
    const {
      headerChildren,
      rightHeader,
      leftHeader,
      bodyChildren,
      footerChildren,
      fullHeader,
      headerBackgroundColor,
      borderLeftHeaderColor,
      borderBottomHeaderColor,
      noHeaderDivider,
      cardHeaderProps
    } = this.props
    return (
      <CardContainer {...this.props} direction='column'>
        <CardHeader
          rightHeader={rightHeader}
          leftHeader={leftHeader}
          fullHeader={fullHeader}
          headerBackgroundColor={headerBackgroundColor}
          borderLeftHeaderColor={borderLeftHeaderColor}
          borderBottomHeaderColor={borderBottomHeaderColor}
          noHeaderDivider={noHeaderDivider}
          {...cardHeaderProps}
        >
          { headerChildren() }
        </CardHeader>
        <div>
          { bodyChildren() }
        </div>
        <CardFooter
        >
          { footerChildren() }
        </CardFooter>
      </CardContainer>
    )
  }
}
